/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import RichTextEditor from "react-rte";
import axios from "../../utils/axiosInstance"; 
import { useNavigate } from "react-router-dom";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);
const useStyles = makeStyles(styles);

export default function AddFAQ() {
  let fileInput = React.createRef();
  const navigate = useNavigate();
  const [formValues, setFormValues] = React.useState({
    question: " ",
    answer: ""
  });
  const [editorBody, setEditorBody] = React.useState(RichTextEditor.createEmptyValue());
  const [alert, setAlert] = React.useState(null);

const handleChange = (e) => {
  setFormValues({
    ...formValues,
    [e.target.id]: e.target.type === 'number'?Number(e.target.value):e.target.value,
  });
  console.log(formValues);
};

const handleEditorChange = (newValue) => {
setEditorBody(newValue);
setFormValues({
    ...formValues,
    "answer":newValue.toString("html"),
  });

};



 
const hideAlert = () => {
  setAlert(null);
  navigate( `/admin/manage-pages/faq`);
};

  const handleSubmitForm = async () => {
            const token = localStorage.getItem("token");
            const formData = new FormData();
           
            for (const key in formValues) {
              formData.append(key, formValues[key]);
            }
            axios.post(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/faq`,
            formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Access-Control-Allow-Origin": "*",
                    }
                }
    
            ).then((res) => {
              setAlert(
                <SweetAlert
                  style={{ display: "block", marginTop: "-100px" }}
                  title={
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {res.data.message}
                    </span>
                  }
                  onConfirm={() => hideAlert()}
                  onCancel={() => hideAlert()}
                  titleCssClass={classesSweetAlert.cardTitle}
                  confirmBtnCssClass={
                    classesSweetAlert.button + " " + classesSweetAlert.success
                  }
                />
              );
            })
                .catch((err) => {
                    console.warn(err);
                    alert(err);
                })
        };
  
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Add FAQ</h4>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Question"
                    id="question"
                    handleChange={handleChange}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type:"text",
                      value: formValues?.question,
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                <RichTextEditor
                  value={editorBody}
                  onChange={handleEditorChange}
                  style={{ height: "300px" }}
                />
              </GridItem>
               
              </GridContainer>

              <Button
                color="rose"
                className={classes.registerButton}
                onClick={handleSubmitForm}
              >
               Submit
              </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
      {alert}
    </GridContainer>
  );
}
